import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postPackageConfig } from "apis";
import { getQueueConfigQueryKey } from "../get-queue-config";

export default function usePostPackageConfig() {
  const queryClient = useQueryClient();

  return useMutation(postPackageConfig, {
    onSuccess: () => {
      queryClient.invalidateQueries(getQueueConfigQueryKey());
    },
  });
}
